/* eslint-disable camelcase */
import * as THREE from 'three'
import { getSeatMaterial } from '../utils/helper_functions'

export const drawLabel = (content, options, textGeometries, materials) => {
  const {
    font,
    color,
    position,
    size,
    center_x,
    center_y,
    scale,
    seat_circle_radius,
    scene,
    rotation = 0,
    opacity = 1
  } = options

  position[0] -= center_x * scale
  position[1] += center_y * scale
  let labelGeometry
  if (textGeometries.get(content)) {
    labelGeometry = textGeometries.get(content)
  } else {
    const labelSize = size || ((seat_circle_radius || 14) * scale * 4) / 5
    labelGeometry = new THREE.TextGeometry(content, {
      font: font,
      size: labelSize,
      height: 0
    })
    textGeometries.set(content, labelGeometry)
  }

  labelGeometry.center()
  const labelMaterial = getSeatMaterial({ color, opacity }, materials)
  const label = new THREE.Mesh(labelGeometry, labelMaterial)
  label.position.set(...position)
  label.rotation.set(0, 0, (rotation * Math.PI) / 180)
  label.renderOrder = 1
  scene.add(label)
  return label
}
